import React from 'react';

import { Th } from 'react-super-responsive-table';

class TableHeader extends React.Component {
  sortUsers = (sortType, name) => {
    this.props.onHeaderClick(sortType, name); 
  }
  render () {
    const fields = this.props
    return (
      <Th className={fields.className}>
        <span className='ScalaSansOT-Bold bold-font pointer'>
          <span id={fields.id} onClick={() => { this.sortUsers(fields.sortType, fields.defaultTitle) }}>
          {fields.heading} <i className={'absolute pLeft-10 pTop-2 fas fa-caret-' + (fields.sortTitle === fields.defaultTitle ? fields.sortType : '')} />
          </span>
        </span>
      </Th>
    )
  }
}

export default TableHeader;
